import React, { useState, useContext } from 'react';
import '@chatscope/chat-ui-kit-styles/dist/default/styles.min.css';
import ChatStream from 'components/BiteAI/ChatStream';
import { useSnackbar } from 'notistack';
import { GlobalContext } from 'providers/GlobalProvider';
import ModuleHeaderLayout from 'components/Common/Layouts/ModuleHeaderLayout';
import RequiredLicense from 'pages/assign/RequiredLicense';
import { LicenseType } from 'pages/assign/LicenseBadge';

// eslint-disable-next-line
const API_BASE = process.env.REACT_APP_PYAPI_URL;

const BiteAIStream: React.FC<any> = () => {
  const [isTyping, setIsTyping] = useState(false);
  const [messages, setMessages] = useState([
    {
      message:
        // eslint-disable-next-line quotes
        "Hello, I'm Biscuit, an AI powered assistant, customized to answer complex global trade questions. I can assist with information gathering, beneficial ownership information, regulatory guidance breakdowns and more. Please enter your question below.",
      sender: 'ChatGPT',
    },
  ]);
  const { enqueueSnackbar } = useSnackbar();
  const { cur_user } = useContext(GlobalContext);

  const requiredTiers = ['pro', 'business', 'enterprise'];
  const userHasBiteGPT = requiredTiers.includes(cur_user?.license);

  const normalizedLicense = (
    ['none', 'standard', 'pro', 'business', 'enterprise'].includes(
      cur_user?.license,
    )
      ? cur_user.license
      : 'none'
  ) as LicenseType;

  const handleSendClick = async (message: string) => {
    const newMessage = {
      message: message,
      direction: 'outgoing',
      sender: 'user',
    };

    setMessages((prevMessages) => [...prevMessages, newMessage]);
    setIsTyping(true);

    try {
      const response = await fetch(`${API_BASE}/ask`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ question: message }),
      });

      if (!response.body) {
        throw new Error('No response body from stream.');
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();

      // Push initial assistant message
      setMessages((prev) => [...prev, { message: '', sender: 'ChatGPT' }]);

      while (true) {
        const { done, value } = await reader.read();
        if (done) {
          break;
        }

        const chunk = decoder.decode(value, { stream: true });

        setMessages((prevMessages) => {
          const updated = [...prevMessages];
          const lastIdx = updated.length - 1;

          updated[lastIdx] = {
            ...updated[lastIdx],
            message: (updated[lastIdx].message || '') + chunk,
          };

          return updated;
        });
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar(`Error processing message: ${error}`, {
        variant: 'error',
        persist: true,
      });
    } finally {
      setIsTyping(false);
    }
  };

  return (
    <ModuleHeaderLayout
      title='Ask'
      helpContent={
        'Biscuit will provide more direct and clear responses to detailed questions. Having issues? contact the BITE Team or visit the OpenAI Status link below to check the current status of OpenAI.'
      }
    >
      <RequiredLicense userLicense={normalizedLicense} minimumLicense='pro' />
      <div className='bite-gpt-iframe'>
        <a
          className='status-link'
          href='https://status.openai.com/'
          target='_blank'
          rel='noreferrer'
        >
          OpenAI Status
        </a>
        <ChatStream
          messages={messages}
          currentStreamingMessage={''}
          isTyping={isTyping}
          statusText={''}
          handleSendClick={handleSendClick}
          isInteractionDisabled={!userHasBiteGPT}
        />
      </div>
    </ModuleHeaderLayout>
  );
};
export default BiteAIStream;
